import moment from 'moment';

function alphaOnly(event: any) {
	if (event.key === 'Backspace') {
		return;
	} else if (!/^[a-z A-Z]*$/.test(event.key)) {
		// alert("Please enter alphabet only");
		event.preventDefault();
	}
}

function alphaNumOnly(event: any) {
	if (event.key === 'Backspace') {
		return;
	} else if (/[^0-9a-zA-Z]/.test(event.key)) {
		event.preventDefault();
	}
}

function numOnly(event: any) {
	if (event.key === 'Backspace') {
		return;
	} else if (/[^0-9]/.test(event.key)) {
		event.preventDefault();
	}
}

function objectHasKey(obj: any, key: any) {
	if (
		obj !== undefined &&
		obj !== null &&
		Object.keys(obj).length > 0 &&
		// eslint-disable-next-line no-prototype-builtins
		obj.hasOwnProperty(key)
	) {
		return true;
	}
	return false;
}

function objectHasKeys(obj: any) {
	if (obj !== undefined && obj !== null && Object.keys(obj).length > 0) {
		return true;
	}
	return false;
}

function validateEmail(emailField: string) {
	const reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
	if (reg.test(emailField)) {
		return false;
	}
	return true;
}

function arrayNotNull(array: any) {
	if (
		array !== undefined &&
		array !== null &&
		Array.isArray(array) &&
		array.length > 0
	) {
		return true;
	}
	return false;
}

function notNull(data: any) {
	if (data !== undefined && data !== null && data !== '') {
		return true;
	}
	return false;
}

function defaultDate(date: any) {
	return moment(date).format('DD/MM/YYYY');
}

function defaultDateTime(date: any) {
	return moment(date).format('DD/MM/YYYY: hh:mm A');
}

export {
	alphaNumOnly,
	alphaOnly,
	objectHasKey,
	objectHasKeys,
	validateEmail,
	arrayNotNull,
	notNull,
	defaultDate,
	defaultDateTime,
	numOnly,
};
